import { cx } from '@emotion/css';
import type { LocationDescriptor } from 'history';
import React from 'react';
import Link from './Link';

const BLACK_LIST_PROPS = ['overrideClassName'];

type Props = {
  overrideClassName?: string;
  className?: string;
  to: LocationDescriptor;
};

const CloseButton = (props: Props) => {
  const linkClassName = props.overrideClassName || cx('close-modal', props.className);
  const linkProps = { ...props, className: linkClassName };
  BLACK_LIST_PROPS.forEach((blackListedProp) => {
    delete linkProps[blackListedProp];
  });
  return (
    <Link {...linkProps}>
      <i className="material-icons">clear</i>
    </Link>
  );
};

CloseButton.defaultProps = {
  onClick: () => {},
  to: null,
  testid: 'modal-close-x',
};
export default CloseButton;
